"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiTheme = require("@kyruus/ui-theme");
var _BasicFadingLinesSpinner = require("./BasicFadingLinesSpinner.styles");
const generateLines = numLines => {
  const arr = [];
  const timeStr = `${(0, _now.default)()}`;
  for (let i = 0; i < numLines; i++) {
    arr.push(/*#__PURE__*/_react.default.createElement("span", {
      key: `${i}-${timeStr}`
    }));
  }
  return arr;
};
const BasicFadingLinesSpinner = _ref => {
  let {
    spinnerSize,
    spinnerColor
  } = _ref;
  switch (spinnerSize) {
    case 'small':
      return /*#__PURE__*/_react.default.createElement(_BasicFadingLinesSpinner.SmallFadingLinesSpinner, {
        spinnerColor: spinnerColor
      }, generateLines(10));
    case 'medium':
      return /*#__PURE__*/_react.default.createElement(_BasicFadingLinesSpinner.MediumFadingLinesSpinner, {
        spinnerColor: spinnerColor
      }, generateLines(12));
    case 'large':
      return /*#__PURE__*/_react.default.createElement(_BasicFadingLinesSpinner.LargeFadingLinesSpinner, {
        spinnerColor: spinnerColor
      }, generateLines(15));
    default:
      return /*#__PURE__*/_react.default.createElement(_BasicFadingLinesSpinner.SmallFadingLinesSpinner, {
        spinnerColor: spinnerColor
      }, generateLines(10));
  }
};
BasicFadingLinesSpinner.propTypes = {
  /**
   * Controls the size of the spinner
   */
  spinnerSize: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /**
   * Controls the color of the spinner
   */
  spinnerColor: _propTypes.default.string
};
BasicFadingLinesSpinner.defaultProps = {
  spinnerSize: 'small',
  spinnerColor: (0, _uiTheme.fromTheme)('color_kyruus')({})
};
var _default = exports.default = BasicFadingLinesSpinner;
BasicFadingLinesSpinner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BasicFadingLinesSpinner",
  "props": {
    "spinnerSize": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "description": "Controls the size of the spinner",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false
    },
    "spinnerColor": {
      "defaultValue": {
        "value": "fromTheme('color_kyruus')({})",
        "computed": true
      },
      "description": "Controls the color of the spinner",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};